import {
  Button,
  Col,
  Row,
  Space,
  Tooltip,
  Typography,
  Upload,
  UploadProps,
} from 'antd'
import type { UploadFile } from 'antd/es/upload/interface'
import React, { useEffect, useState } from 'react'
import { RemoveIco } from '@modules/CustomIcons'
import { t } from 'i18next'
import styles from './UploadInput.module.scss'
import { PaperClipOutlined } from '@ant-design/icons'
import ButtonGlobal from '@shared/Button'
import { RcFile } from 'antd/lib/upload'
import { msFileUpload } from '../../app/services/msfileupload'
import * as yup from 'yup'
import { useController, useForm, useWatch } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if(file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    }
  });
};

export type UploadInputProps = UploadProps & {
  label?: string
  onUpload?: (handleUpload: () => Promise<string>) => void
  onSend?: (fileList: UploadFile[]) => void
}

const fileSchema = yup.object().shape({
  files: yup
    .array()
    .of(
      yup
        .mixed()
        .test('fileType', 'Sadəcə PDF faylı yükləyə bilərsiz!', (value) => {
          if (!value) return false
          return value.type === 'application/pdf'
        })
        .test('fileSize', 'Fayl ölçüsü maksimum 1MB ola bilər', (value) => {
          if (!value) return false
          return value.size <= 1024 * 1024
        })
    )
    .min(1, 'Ən azı bir fayl yükləməlisiniz')
});

function UploadInput(props: UploadInputProps) {
  const {
    label,
    multiple,
    onSend,
    disabled,
    beforeUpload,
    onUpload,
    fileList,
    ...rest
  } = props
  // const [mulltiFiles, setMultiFiles] = useState<UploadFile[]>(fileList ?? [])
  const { control, setValue } = useForm<{ files: RcFile[] }>({
    mode: 'all',
    defaultValues: {
      files: []
    },
    resolver: yupResolver(fileSchema)
  })

  const { field: { value: watchFile, onChange }, fieldState: { invalid, error } } = useController({ control, name: 'files' })

  const defaultOptions: UploadInputProps = {
    multiple: multiple || false,
    showUploadList: false,
    beforeUpload(file) {
      if (multiple) {
        onChange([...watchFile, file])
      } else {
        onChange([file])
      }

      return false
    },
    ...rest,
  }

  const handleRemove = (file: UploadFile) => {
    onChange([])
    // todo setMultiFiles((prevFiles) => prevFiles.filter((f) => f.uid !== file.uid))
  }

  const handleSubmit = async () => {
      const base64 = await fileToBase64(watchFile[0] as unknown as File);
      console.log("🚀 ~ handleSubmit ~ base64:", base64)
      // const data = await msFileUpload(base64)

      return base64
  }

  useEffect(() => {
    (async () => {
      return !invalid && onUpload && onUpload(handleSubmit)
    })()
  }, [watchFile])

  useEffect(() => {
    setValue('files', [], { shouldValidate: true })
  }, [])

  return (
    <Space>
      <Row className={`${invalid && styles.uploadError} ${styles.uploadInput}`}>
        <Col span={22}>
          <Tooltip
            popupVisible={watchFile.length === 0}
            title={watchFile.length === 1 && watchFile[0].name}
          >
            <Upload
              disabled={disabled}
              {...defaultOptions}
              fileList={watchFile}
              listType="text"
            >
              <Typography.Text>
                {watchFile.length > 0
                  ? multiple && watchFile.length > 1
                    ? `(${watchFile.length}) fayl seçilib`
                    : watchFile[0].name
                  : label
                  ? label
                  : t('salary.chooseFile')}
              </Typography.Text>
            </Upload>
          </Tooltip>
        </Col>
        <Col span={2}>
          {watchFile.length > 0 ? (
            <Button
              disabled={disabled}
              type="text"
              onClick={() => handleRemove(watchFile?.[0])}
              icon={<RemoveIco />}
            />
          ) : (
            <Button
              disabled={disabled}
              type="text"
              onClick={() => {}}
              icon={<PaperClipOutlined />}
            />
          )}
        </Col>
      </Row>
      {onSend && <ButtonGlobal
        loading={disabled}
        disabled={disabled || watchFile.length === 0}
        onClick={() => onSend(watchFile)}
        customType="primary"
      >
        {t('orders.salaryCardOrder.buttonsLabels.download')}
      </ButtonGlobal> }
    </Space>
  )
}

export default UploadInput
